(() => {
  'use strict';

  const root =
    document.querySelector('[data-pnai]');

  if (!root) return;


  const path =
    window.location.pathname.toLowerCase();


  const blocked =
    [
      '/pages/login',
      '/pages/reset-password',
      '/pages/admin'
    ];


  if (
    blocked.some(item =>
      path.startsWith(item)
    )
  ) {
    return;
  }


  root.hidden = false;


  /* PN7_MONKEY_CARD_TOUR */

  const prefersReducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;


  const mascotForTour =
    root.querySelector(
      '[data-pnai-toggle]'
    );


  const bubbleForTour =
    root.querySelector(
      '.pnai-arrival-bubble'
    );


  const tourArm =
    root.querySelector(
      '.pnai-monkey__arm--right'
    );


  const sleep = ms =>
    new Promise(
      resolve =>
        window.setTimeout(
          resolve,
          ms
        )
    );


  const nextPaint = () =>
    new Promise(
      resolve => {

        requestAnimationFrame(
          () => {

            requestAnimationFrame(
              resolve
            );

          }
        );

      }
    );


  function pose(
    x,
    y,
    rotation = 0,
    scale = 1
  ) {

    return (
      `translate(${x}px, ${y}px) ` +
      `rotate(${rotation}deg) ` +
      `scale(${scale})`
    );

  }


  async function animateMascot(
    frames,
    duration,
    easing =
      'cubic-bezier(.2,.82,.3,1)'
  ) {

    const animation =
      mascotForTour.animate(
        frames,
        {
          duration,
          easing,
          fill:'forwards'
        }
      );


    try {

      await animation.finished;

    }
    catch (_) {}


    const finalTransform =
      frames[
        frames.length - 1
      ]?.transform;


    if (
      typeof animation.commitStyles ===
      'function'
    ) {

      animation.commitStyles();

    }
    else if (
      finalTransform
    ) {

      mascotForTour.style.transform =
        finalTransform;

    }


    animation.cancel();

  }


  function showTourBubble(
    text
  ) {

    if (!bubbleForTour) {
      return;
    }


    bubbleForTour.textContent =
      text;


    bubbleForTour
      .getAnimations()
      .forEach(
        animation =>
          animation.cancel()
      );


    bubbleForTour.animate(
      [
        {
          opacity:0,
          transform:
            'translateY(8px) scale(.9) rotate(-4deg)'
        },
        {
          opacity:1,
          transform:
            'translateY(0) scale(1.04) rotate(-2deg)',
          offset:.28
        },
        {
          opacity:1,
          transform:
            'translateY(0) scale(1) rotate(-2deg)',
          offset:.68
        },
        {
          opacity:0,
          transform:
            'translateY(-7px) scale(.96) rotate(1deg)'
        }
      ],
      {
        duration:850,
        easing:'ease',
        fill:'both'
      }
    );

  }


  function cardReaction(
    card
  ) {

    if (!card) {
      return;
    }


    card.classList.remove(
      'pnai-card-land'
    );


    void card.offsetWidth;


    card.classList.add(
      'pnai-card-land'
    );


    window.setTimeout(
      () => {

        card.classList.remove(
          'pnai-card-land'
        );

      },
      500
    );

  }


  function cardName(
    card
  ) {

    return (
      card
        ?.querySelector('h3')
        ?.textContent
        ?.trim()
      ||
      'next stop'
    );

  }


  async function jump(
    from,
    to,
    spin,
    duration = 650,
    height = 82
  ) {

    const deltaX =
      to.x - from.x;


    const peakX =
      from.x +
      deltaX * .5;


    const peakY =
      Math.min(
        from.y,
        to.y
      )
      - height;


    await animateMascot(
      [
        {
          transform:
            pose(
              from.x,
              from.y,
              0,
              1
            ),
          offset:0
        },

        {
          transform:
            pose(
              from.x +
              deltaX * .18,
              from.y - 25,
              spin * .15,
              1.03
            ),
          offset:.18
        },

        {
          transform:
            pose(
              peakX,
              peakY,
              spin * .52,
              1.08
            ),
          offset:.5
        },

        {
          transform:
            pose(
              to.x -
              deltaX * .09,
              to.y - 20,
              spin * .88,
              1.035
            ),
          offset:.82
        },

        {
          transform:
            pose(
              to.x,
              to.y,
              spin,
              1
            ),
          offset:1
        }
      ],
      duration
    );

  }


  function landingPoint(
    baseRect,
    card
  ) {

    const rect =
      card.getBoundingClientRect();


    /*
     * Land toward the right half of the card
     * so the monkey does not cover the title/icon.
     */

    const x =
      (
        rect.left +
        rect.width * .73
      )
      -
      (
        baseRect.left +
        baseRect.width / 2
      );


    /*
     * Feet sit just inside the card's top paper edge.
     */

    const y =
      (
        rect.top + 13
      )
      -
      baseRect.bottom;


    return {
      x,
      y,
      card
    };

  }


  async function finishTour() {

    mascotForTour.style.transform =
      '';


    root.classList.remove(
      'is-touring'
    );


    root.classList.add(
      'is-ready'
    );


    showTourBubble(
      'ask me anything ✦'
    );


    if (tourArm) {

      tourArm.animate(
        [
          {
            transform:
              'rotate(-24deg)'
          },
          {
            transform:
              'rotate(-72deg)'
          },
          {
            transform:
              'rotate(-18deg)'
          },
          {
            transform:
              'rotate(-68deg)'
          },
          {
            transform:
              'rotate(-24deg)'
          }
        ],
        {
          duration:720,
          easing:'ease-in-out'
        }
      );

    }

  }


  async function homepageCardTour(
    cards
  ) {

    root.classList.add(
      'is-touring'
    );


    await nextPaint();


    const base =
      mascotForTour
        .getBoundingClientRect();


    const stops =
      cards.map(
        card =>
          landingPoint(
            base,
            card
          )
      );


    if (!stops.length) {

      await finishTour();
      return;

    }


    /*
     * Start outside the left side of the viewport.
     */

    let current = {
      x:
        -base.right - 45,

      y:
        stops[0].y + 22
    };


    mascotForTour.style.transform =
      pose(
        current.x,
        current.y,
        -8,
        .92
      );


    showTourBubble(
      'coming through! ✦'
    );


    /*
     * Enter and land on COLLEGES.
     */

    await jump(
      current,
      stops[0],
      360,
      760,
      72
    );


    current =
      stops[0];


    cardReaction(
      stops[0].card
    );


    showTourBubble(
      `${cardName(stops[0].card)}!`
    );


    await sleep(130);


    /*
     * COLLEGES → MENTORS
     * front flip
     */

    if (stops[1]) {

      await jump(
        current,
        stops[1],
        360,
        620,
        78
      );


      current =
        stops[1];


      cardReaction(
        stops[1].card
      );


      showTourBubble(
        'wheee! ✦'
      );


      await sleep(110);

    }


    /*
     * MENTORS → EVENTS
     * backflip
     */

    if (stops[2]) {

      await jump(
        current,
        stops[2],
        -360,
        650,
        92
      );


      current =
        stops[2];


      cardReaction(
        stops[2].card
      );


      showTourBubble(
        'backflip!'
      );


      await sleep(110);

    }


    /*
     * EVENTS → COMMUNITIES
     * double front flip
     */

    if (stops[3]) {

      await jump(
        current,
        stops[3],
        720,
        720,
        86
      );


      current =
        stops[3];


      cardReaction(
        stops[3].card
      );


      showTourBubble(
        'made it! ♡'
      );


      await sleep(160);

    }


    /*
     * Final jump from the last card
     * to the permanent AI dock.
     */

    await jump(
      current,
      {
        x:0,
        y:0
      },
      -360,
      680,
      72
    );


    await finishTour();

  }


  async function simplePageEntrance() {

    root.classList.add(
      'is-touring'
    );


    await nextPaint();


    const base =
      mascotForTour
        .getBoundingClientRect();


    const start = {
      x:
        -base.right - 35,
      y:5
    };


    mascotForTour.style.transform =
      pose(
        start.x,
        start.y,
        -6,
        .92
      );


    showTourBubble(
      'hii! 👋'
    );


    await animateMascot(
      [
        {
          transform:
            pose(
              start.x,
              start.y,
              -6,
              .92
            ),
          offset:0
        },

        {
          transform:
            pose(
              start.x * .65,
              -65,
              180,
              1.05
            ),
          offset:.34
        },

        {
          transform:
            pose(
              start.x * .32,
              5,
              360,
              1
            ),
          offset:.61
        },

        {
          transform:
            pose(
              start.x * .14,
              -45,
              540,
              1.04
            ),
          offset:.8
        },

        {
          transform:
            pose(
              0,
              0,
              720,
              1
            ),
          offset:1
        }
      ],
      1500
    );


    await finishTour();

  }


  async function startMonkeyTour() {

    if (
      prefersReducedMotion ||
      !mascotForTour
    ) {

      root.classList.add(
        'is-ready'
      );

      return;

    }


    /*
     * The homepage already has four real discovery
     * cards: Colleges, Mentors, Events, Communities.
     */

    const cards =
      Array.from(
        document.querySelectorAll(
          '.pn-hero-feature'
        )
      )
        .slice(0,4)
        .filter(
          card => {

            const rect =
              card.getBoundingClientRect();


            return (
              rect.width > 20 &&
              rect.height > 20 &&
              rect.top < window.innerHeight &&
              rect.bottom > 0
            );

          }
        );


    if (
      cards.length >= 2
    ) {

      await homepageCardTour(
        cards
      );

    }
    else {

      await simplePageEntrance();

    }

  }


  const beginMonkeyTour = () => {

    window.setTimeout(
      startMonkeyTour,
      180
    );

  };


  if (
    document.readyState ===
    'complete'
  ) {

    beginMonkeyTour();

  }
  else {

    window.addEventListener(
      'load',
      beginMonkeyTour,
      {
        once:true
      }
    );

  }


  const toggle =
    root.querySelector('[data-pnai-toggle]');

  const close =
    root.querySelector('[data-pnai-close]');

  const drawer =
    root.querySelector('[data-pnai-drawer]');

  const form =
    root.querySelector('[data-pnai-form]');

  const input =
    root.querySelector('[data-pnai-input]');

  const send =
    root.querySelector('[data-pnai-send]');

  const chat =
    root.querySelector('[data-pnai-chat]');

  const quick =
    root.querySelector('[data-pnai-quick]');

  const context =
    root.querySelector('[data-pnai-context]');

  const usage =
    root.querySelector('[data-pnai-usage]');


  function escapeHTML(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function setOpen(open) {

    root.classList.toggle(
      'is-open',
      open
    );

    drawer.setAttribute(
      'aria-hidden',
      open ? 'false' : 'true'
    );

    toggle.setAttribute(
      'aria-expanded',
      open ? 'true' : 'false'
    );

    if (open) {
      setTimeout(() => input.focus(), 100);
    }

  }


  function append(role, text) {

    const item =
      document.createElement('article');

    item.className =
      `pnai-message pnai-message--${role}`;

    item.innerHTML = `
      <span>${role === 'assistant' ? '🐵' : ''}</span>
      <p>${escapeHTML(text)}</p>
    `;

    chat.appendChild(item);

    chat.scrollTop =
      chat.scrollHeight;

  }


  function prompts() {

    if (path.includes('college')) {
      return [
        'Tell me about this college',
        'Check my admission outlook',
        'Find mentors here'
      ];
    }

    if (path.includes('mentor')) {
      return [
        'Is this mentor right for me?',
        'What should I ask a mentor?',
        'Show my college matches'
      ];
    }

    if (path.includes('event')) {
      return [
        'Is this event useful for me?',
        'What events should I explore?',
        'How does this help me?'
      ];
    }

    if (path.includes('compare')) {
      return [
        'Explain this comparison',
        'Which college fits me better?',
        'What should I prioritize?'
      ];
    }

    return [
      'Review my college matches',
      'Help me with my rank',
      'Help me choose a college'
    ];

  }


  function renderPrompts() {

    quick.innerHTML =
      prompts()
        .map(prompt => `
          <button
            type="button"
            data-pnai-prompt="${escapeHTML(prompt)}"
          >
            ${escapeHTML(prompt)}
          </button>
        `)
        .join('');


    quick
      .querySelectorAll('[data-pnai-prompt]')
      .forEach(button => {

        button.addEventListener(
          'click',
          () => {

            input.value =
              button.dataset.pnaiPrompt || '';

            form.requestSubmit();

          }
        );

      });

  }


  /* PN7_MONKEY_NAVIGATION */

  const navigationRoutes = [

    {
      keys:[
        'home',
        'homepage',
        'peer nest home',
        'peernest home'
      ],
      path:'/',
      label:'home'
    },

    {
      keys:[
        'college',
        'colleges',
        'explore colleges',
        'college search'
      ],
      path:'/pages/colleges',
      label:'colleges'
    },

    {
      keys:[
        'compare',
        'comparison',
        'compare colleges'
      ],
      path:'/pages/compare',
      label:'Compare'
    },

    {
      keys:[
        'mentor',
        'mentors',
        'find mentors',
        'find a mentor'
      ],
      path:'/pages/mentors',
      label:'mentors'
    },

    {
      keys:[
        'event',
        'events',
        'discover events'
      ],
      path:'/pages/events',
      label:'events'
    },

    {
      keys:[
        'community',
        'communities',
        'discover communities'
      ],
      path:'/pages/communities',
      label:'communities'
    },

    {
      keys:[
        'dashboard',
        'my dashboard',
        'student dashboard'
      ],
      path:'/pages/student-dashboard',
      label:'your dashboard'
    },

    {
      keys:[
        'matches',
        'my matches',
        'college matches',
        'match profile'
      ],
      path:'/pages/student-dashboard#college-journey',
      label:'your college matches'
    },

    {
      keys:[
        'peernest ai',
        'ai page',
        'my ai'
      ],
      path:'/pages/student-dashboard#peernest-ai',
      label:'PeerNest AI'
    },

    {
      keys:[
        'profile',
        'my profile',
        'account'
      ],
      path:'/pages/profile',
      label:'your profile'
    },

    {
      keys:[
        'become a mentor',
        'mentor application'
      ],
      path:'/pages/become-a-mentor',
      label:'mentor application'
    }

  ];


  function normalizeNavigationText(value) {

    return String(value || '')
      .toLowerCase()
      .replace(/[?!.,]/g,' ')
      .replace(/\s+/g,' ')
      .trim();

  }


  function navigationIntent(message) {

    const text =
      normalizeNavigationText(
        message
      );


    const navigationWords =
      [
        'go to ',
        'take me to ',
        'take me ',
        'open ',
        'show me ',
        'navigate to ',
        'bring me to ',
        'visit ',
        'explore '
      ];


    const looksLikeNavigation =
      navigationWords.some(
        phrase =>
          text.startsWith(phrase)
      );


    if (!looksLikeNavigation) {
      return null;
    }


    const cleaned =
      navigationWords.reduce(
        (value, phrase) =>
          value.startsWith(phrase)
            ? value.slice(
                phrase.length
              ).trim()
            : value,
        text
      );


    return navigationRoutes.find(
      route =>
        route.keys.some(
          key =>
            cleaned === key ||
            cleaned.includes(key)
        )
    ) || null;

  }


  async function monkeyNavigate(route) {

    if (!route) {
      return false;
    }


    append(
      'assistant',
      `Yesss — follow me! 🐵✨ Taking you to ${route.label}.`
    );


    root.classList.add(
      'pnai-is-navigating'
    );


    const mascot =
      root.querySelector(
        '[data-pnai-toggle]'
      );


    if (
      mascot &&
      !window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {

      const animation =
        mascot.animate(
          [
            {
              transform:
                'translateY(0) rotate(0deg) scale(1)'
            },

            {
              transform:
                'translateY(-24px) rotate(-12deg) scale(1.04)',
              offset:.28
            },

            {
              transform:
                'translateY(0) rotate(9deg) scale(.98)',
              offset:.55
            },

            {
              transform:
                'translateY(-12px) rotate(18deg) scale(1.03)',
              offset:.76
            },

            {
              transform:
                'translateX(70px) translateY(-5px) rotate(35deg) scale(.85)',
              opacity:0
            }
          ],
          {
            duration:650,
            easing:
              'cubic-bezier(.22,.8,.3,1)',
            fill:'forwards'
          }
        );


      try {
        await animation.finished;
      }
      catch (_) {}

    }
    else {

      await new Promise(
        resolve =>
          window.setTimeout(
            resolve,
            300
          )
      );

    }


    window.location.href =
      route.path;


    return true;

  }


  /* PN7_CONTEXT_GUIDE */

  const guideStoragePrefix =
    'pnai_guide_seen:';


  const guideGlobalStorageKey =
    'pnai_guide_last_shown';


  const GUIDE_GLOBAL_COOLDOWN =
    45000;


  function guideRPC(
    name,
    body = {}
  ) {

    return window.PeerNestDB.request(
      `rpc/${name}`,
      '',
      {
        method:'POST',
        body
      }
    );

  }


  function normalizeRPCObject(
    value
  ) {

    if (
      Array.isArray(value)
    ) {

      return value[0] || null;

    }


    return value || null;

  }


  function guideWasRecentlyShown() {

    try {

      const last =
        Number(
          sessionStorage.getItem(
            guideGlobalStorageKey
          ) || 0
        );


      return (
        Date.now() - last
      ) < GUIDE_GLOBAL_COOLDOWN;

    }
    catch (_) {

      return false;

    }

  }


  function guideWasSeenHere() {

    try {

      return (
        sessionStorage.getItem(
          guideStoragePrefix +
          window.location.pathname
        ) === '1'
      );

    }
    catch (_) {

      return false;

    }

  }


  function rememberGuideShown() {

    try {

      sessionStorage.setItem(
        guideStoragePrefix +
        window.location.pathname,
        '1'
      );


      sessionStorage.setItem(
        guideGlobalStorageKey,
        String(
          Date.now()
        )
      );

    }
    catch (_) {}

  }


  function waitForMonkeyTour() {

    return new Promise(
      resolve => {

        let checks = 0;


        const check = () => {

          checks += 1;


          if (
            !root.classList.contains(
              'is-touring'
            )

            ||

            checks > 50
          ) {

            resolve();
            return;

          }


          window.setTimeout(
            check,
            100
          );

        };


        check();

      }
    );

  }


  function ensureGuideBubble() {

    let guide =
      root.querySelector(
        '[data-pnai-guide]'
      );


    if (guide) {
      return guide;
    }


    guide =
      document.createElement(
        'div'
      );


    guide.className =
      'pnai-guide';


    guide.dataset
      .pnaiGuide = '';


    guide.hidden =
      true;


    guide.innerHTML = `
      <button
        type="button"
        class="pnai-guide__close"
        data-pnai-guide-close
        aria-label="Dismiss suggestion"
      >
        ×
      </button>

      <div class="pnai-guide__face">
        🐵
      </div>

      <div class="pnai-guide__copy">

        <small>
          PEERNEST GUIDE
        </small>

        <strong
          data-pnai-guide-title
        ></strong>

        <p
          data-pnai-guide-text
        ></p>

        <button
          type="button"
          class="pnai-guide__action"
          data-pnai-guide-action
        ></button>

      </div>
    `;


    root.appendChild(
      guide
    );


    guide
      .querySelector(
        '[data-pnai-guide-close]'
      )
      .addEventListener(
        'click',
        () => {

          guide.classList.remove(
            'is-visible'
          );


          window.setTimeout(
            () => {

              guide.hidden =
                true;

            },
            220
          );

        }
      );


    return guide;

  }


  async function dashboardGuideSuggestion() {

    if (
      !window.PeerNestDB
    ) {
      return null;
    }


    let session =
      null;


    try {

      session =
        await window.PeerNestDB
          .getSession();

    }
    catch (_) {}


    if (
      !session?.access_token
    ) {

      return {
        title:
          'Want your own college matches?',

        text:
          'Sign in and I’ll guide you through Match, Rank Predictor and your shortlist.',

        action:
          'Take me to login',

        route:{
          path:'/pages/login',
          label:'login'
        }
      };

    }


    const [
      preferenceResult,
      matchResult,
      examResult
    ] =
      await Promise.allSettled([

        guideRPC(
          'get_my_match_preferences'
        ),

        guideRPC(
          'get_my_college_matches',
          {
            p_limit:12
          }
        ),

        guideRPC(
          'get_my_exam_profiles'
        )

      ]);


    const preferences =
      preferenceResult.status ===
        'fulfilled'
        ? normalizeRPCObject(
            preferenceResult.value
          )
        : null;


    const matches =
      matchResult.status ===
        'fulfilled'

        &&

        Array.isArray(
          matchResult.value
        )
          ? matchResult.value
          : [];


    const exams =
      examResult.status ===
        'fulfilled'

        &&

        Array.isArray(
          examResult.value
        )
          ? examResult.value
          : [];


    if (
      !preferences?.completed_at
    ) {

      return {
        title:
          'Psst… start with your Match Profile 👀',

        text:
          'Tell me what you want in a college and PeerNest can rank the best fits for you.',

        action:
          'Show me where',

        selector:
          '[data-pnmatch-root]'
      };

    }


    if (!matches.length) {

      return {
        title:
          'Your Match Profile is ready ✦',

        text:
          'Now generate your personalized college matches.',

        action:
          'Take me to matches',

        selector:
          '[data-pnintel-results]'
      };

    }


    if (!exams.length) {

      return {
        title:
          'Your matches are ready! 🐵',

        text:
          'Add an entrance exam next and I can help with Rank Predictor and Admission Outlook.',

        action:
          'Show me Rank Predictor',

        selector:
          '[data-pnintel-exam-form]'
      };

    }


    return {
      title:
        'You’re all set ✨',

      text:
        'Want to review your matches and check admission outlooks?',

      action:
        'Review my matches',

      selector:
        '[data-pnintel-results]'
    };

  }


  async function contextualGuideSuggestion() {

    const currentPath =
      window.location.pathname
        .toLowerCase();


    if (
      currentPath === '/'
    ) {

      return {
        title:
          'Not sure where to start?',

        text:
          'I can take you straight to colleges and help you begin exploring.',

        action:
          'Explore colleges',

        route:{
          path:'/pages/colleges',
          label:'colleges'
        }
      };

    }


    if (
      currentPath ===
      '/pages/colleges'
    ) {

      return {
        title:
          'Found a few you like? 👀',

        text:
          'Compare colleges side by side before you shortlist them.',

        action:
          'Take me to Compare',

        route:{
          path:'/pages/compare',
          label:'Compare'
        }
      };

    }


    if (
      currentPath.startsWith(
        '/pages/college'
      )

      &&

      currentPath !==
        '/pages/colleges'
    ) {

      return {
        title:
          'Want the student perspective?',

        text:
          'I know where the PeerNest mentors are 🐵',

        action:
          'Find mentors',

        route:{
          path:'/pages/mentors',
          label:'mentors'
        }
      };

    }


    if (
      currentPath.startsWith(
        '/pages/compare'
      )
    ) {

      return {
        title:
          'Comparison done?',

        text:
          'Your personal Match can tell you which colleges fit your priorities best.',

        action:
          'Show my matches',

        route:{
          path:'/pages/student-dashboard#college-journey',
          label:'your college matches'
        }
      };

    }


    if (
      currentPath ===
        '/pages/mentors'

      ||

      currentPath.startsWith(
        '/pages/mentor/'
      )
    ) {

      return {
        title:
          'Want to explore their college too?',

        text:
          'I can take you back to college discovery whenever you’re ready.',

        action:
          'Explore colleges',

        route:{
          path:'/pages/colleges',
          label:'colleges'
        }
      };

    }


    if (
      currentPath.startsWith(
        '/pages/events'
      )
    ) {

      return {
        title:
          'Looking for your people too?',

        text:
          'Communities are right next door — come on, this way!',

        action:
          'Explore communities',

        route:{
          path:'/pages/communities',
          label:'communities'
        }
      };

    }


    if (
      currentPath.startsWith(
        '/pages/communities'
      )
    ) {

      return {
        title:
          'Want something to join?',

        text:
          'I can show you PeerNest events, workshops and student experiences.',

        action:
          'Explore events',

        route:{
          path:'/pages/events',
          label:'events'
        }
      };

    }


    if (
      currentPath.includes(
        'student-dashboard'
      )

      ||

      currentPath.includes(
        'student-college-journey'
      )

      ||

      currentPath.includes(
        'student-ai'
      )
    ) {

      return dashboardGuideSuggestion();

    }


    return null;

  }


  async function scrollWithMonkey(
    selector,
    label
  ) {

    const target =
      document.querySelector(
        selector
      );


    if (!target) {
      return false;
    }


    append(
      'assistant',
      `Yep — right this way! 🐵✨`
    );


    setOpen(
      false
    );


    if (
      mascotForTour &&
      !prefersReducedMotion
    ) {

      const animation =
        mascotForTour.animate(
          [
            {
              transform:
                'translateY(0) rotate(0deg)'
            },

            {
              transform:
                'translateY(-22px) rotate(-10deg)',
              offset:.35
            },

            {
              transform:
                'translateY(0) rotate(8deg)',
              offset:.65
            },

            {
              transform:
                'translateY(-8px) rotate(0deg)'
            }
          ],
          {
            duration:520,
            easing:
              'cubic-bezier(.22,.8,.3,1)'
          }
        );


      try {
        await animation.finished;
      }
      catch (_) {}

    }


    target.scrollIntoView({
      behavior:
        prefersReducedMotion
          ? 'auto'
          : 'smooth',

      block:'center'
    });


    target.classList.add(
      'pnai-guide-target'
    );


    window.setTimeout(
      () => {

        target.classList.remove(
          'pnai-guide-target'
        );

      },
      1600
    );


    return true;

  }


  async function showContextGuide() {

    if (
      guideWasSeenHere()
      ||
      guideWasRecentlyShown()
    ) {

      return;

    }


    await waitForMonkeyTour();


    const suggestion =
      await contextualGuideSuggestion();


    if (!suggestion) {
      return;
    }


    const guide =
      ensureGuideBubble();


    const title =
      guide.querySelector(
        '[data-pnai-guide-title]'
      );


    const text =
      guide.querySelector(
        '[data-pnai-guide-text]'
      );


    const action =
      guide.querySelector(
        '[data-pnai-guide-action]'
      );


    title.textContent =
      suggestion.title;


    text.textContent =
      suggestion.text;


    action.textContent =
      suggestion.action;


    const freshAction =
      action.cloneNode(
        true
      );


    action.replaceWith(
      freshAction
    );


    freshAction.addEventListener(
      'click',
      async () => {

        guide.classList.remove(
          'is-visible'
        );


        if (
          suggestion.selector
        ) {

          const handled =
            await scrollWithMonkey(
              suggestion.selector,
              suggestion.title
            );


          if (handled) {
            return;
          }

        }


        if (
          suggestion.route
        ) {

          await monkeyNavigate(
            suggestion.route
          );

        }

      }
    );


    rememberGuideShown();


    guide.hidden =
      false;


    requestAnimationFrame(
      () => {

        guide.classList.add(
          'is-visible'
        );

      }
    );


    /*
     * Do not keep nagging the student.
     * The suggestion quietly leaves after 11 seconds.
     */

    window.setTimeout(
      () => {

        if (
          guide.hidden
          ||
          guide.matches(':hover')
        ) {
          return;
        }


        guide.classList.remove(
          'is-visible'
        );


        window.setTimeout(
          () => {

            guide.hidden =
              true;

          },
          220
        );

      },
      11000
    );

  }


  function scheduleContextGuide() {

    window.setTimeout(
      showContextGuide,
      900
    );

  }


  async function ask(message) {

    if (!window.PeerNestDB) {
      append(
        'assistant',
        'PeerNest is still connecting. Try again in a moment.'
      );
      return;
    }


    let session = null;

    try {
      session =
        await window.PeerNestDB.getSession();
    }
    catch (_) {}


    if (!session?.access_token) {

      append(
        'assistant',
        'Sign in to use PeerNest AI so I can safely use your matches and exam profile.'
      );

      return;

    }


    send.disabled = true;
    send.textContent = 'Thinking…';


    try {

      const result =
        await window.PeerNestDB.invokeFunction(
          'peernest-ai',
          {
            message,
            page: {
              pathname:
                window.location.pathname,

              search:
                window.location.search,

              title:
                document.title
            }
          }
        );


      append(
        'assistant',
        result?.answer ||
        'PeerNest could not generate an answer yet.'
      );


      if (
        result?.remaining !== undefined
      ) {

        usage.textContent =
          `${result.remaining} AI questions left this month`;

      }

    }
    catch (error) {

      append(
        'assistant',
        error?.message ||
        'PeerNest AI is unavailable right now.'
      );

    }
    finally {

      send.disabled = false;
      send.textContent = 'Send ↑';

    }

  }


  toggle.addEventListener(
    'click',
    () => {
      setOpen(
        !root.classList.contains('is-open')
      );
    }
  );


  close.addEventListener(
    'click',
    () => setOpen(false)
  );


  document.addEventListener(
    'click',
    event => {

      const opener =
        event.target.closest('[data-pnai-open]');

      if (opener) {
        setOpen(true);
      }

    }
  );


  form.addEventListener(
    'submit',
    async event => {

      event.preventDefault();

      const message =
        String(input.value || '').trim();

      if (!message) return;

      input.value = '';

      append(
        'user',
        message
      );


      const route =
        navigationIntent(
          message
        );


      if (route) {

        await monkeyNavigate(
          route
        );

        return;

      }


      await ask(message);

    }
  );


  input.addEventListener(
    'keydown',
    event => {

      if (
        event.key === 'Enter' &&
        !event.shiftKey
      ) {

        event.preventDefault();
        form.requestSubmit();

      }

    }
  );


  context.textContent =
    'I’m focused on colleges, courses, admissions, ranks, mentors, events and your PeerNest journey.';


  renderPrompts();

  scheduleContextGuide();

})();
